import { Item } from '@react-stately/collections'
import { BrandVoice, ChangeLength, ImproveQuality, Translate } from 'almanac-ui/icons'
import { Menu } from 'components/Menu/Menu'
import { Key } from 'react'
import { useAlmanacEditorState } from 'stores/EditorState'
import { useModals } from 'almanac-ui/Modal'
import { ChangeLengthModal } from 'components/BlazeCommandLine/modals/ChangeLengthModal'
import { ChangeToneModal } from 'components/BlazeCommandLine/modals/ChangeToneModal'
import { Selection } from 'prosemirror-state'
import { TranslateModal } from 'components/BlazeCommandLine/modals/TranslateModal'
import { useImproveQuality } from 'hooks/useImproveQuality'

interface Props {
  articleId: string
  layerId: string
  selection?: Selection
  previousRevisionId?: string
}

export const ReviseMenu = ({ articleId, layerId, selection, previousRevisionId }: Props) => {
  const stateContext = useAlmanacEditorState()
  const { openModal } = useModals()

  const { improveQuality } = useImproveQuality({ articleId, layerId })

  const handleAction = (key: Key) => {
    if (!stateContext) return

    switch (key) {
      case 'change-length':
        openModal(ChangeLengthModal, {
          articleId,
          layerId,
          almanacEditorState: stateContext,
          selection: (selection || stateContext.selection).toJSON(),
          previousRevisionId,
        })
        return
      case 'translate':
        openModal(TranslateModal, {
          articleId,
          layerId,
          almanacEditorState: stateContext,
          selection: (selection || stateContext.selection).toJSON(),
          previousRevisionId,
        })
        return
      case 'change-tone':
        openModal(ChangeToneModal, {
          articleId,
          layerId,
          almanacEditorState: stateContext,
          selection: (selection || stateContext.selection).toJSON(),
          previousRevisionId,
        })
        return
      case 'improve':
        improveQuality()
        return
    }
  }

  return (
    <Menu onAction={handleAction} aria-label="Revise Menu">
      <Item key="change-length" textValue="Change Length">
        <>
          <ChangeLength />
          Change Length
        </>
      </Item>
      <Item key="change-tone" textValue="Change Tone">
        <>
          <BrandVoice />
          Change Tone
        </>
      </Item>
      <Item key="improve" textValue="Improve Quality">
        <>
          <ImproveQuality />
          Improve
        </>
      </Item>
      <Item key="translate" textValue="Translate">
        <>
          <Translate />
          Translate
        </>
      </Item>
    </Menu>
  )
}
